// extracted by mini-css-extract-plugin
export default {"wrap":"detail-tab-module_wrap_oHens","wrapChart":"detail-tab-module_wrapChart_bxtKV","workingLeads":"detail-tab-module_workingLeads_veB3f","num":"detail-tab-module_num_pP41p"};